/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Translation_Import_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Importing translation events failed: {error}" |
*
* @param {Translation_Import_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_import_failed_toast = /** @type {((inputs: Translation_Import_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Import_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`L'importation des événements de traduction a échoué : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Import der Übersetzungsereignisse fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Importazione degli eventi di traduzione non riuscita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось импортировать события перевода: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error al importar los eventos de traducción: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`导入翻译事件失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`翻訳イベントのインポートに失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`अनुवाद संबंधी इवेंट आयात करने में विफलता: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`A importação de eventos de tradução falhou: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Importing translation events failed: ${i?.error}`)
});